export const ProductSourceProviderEnum = Object.freeze({
  Ali1688: 'Ali1688',
  Billz: 'Billz',
  // more providers ...
});
